import { getMarket } from '../../../i18n';
import fieldValidation from '../../../utils/fieldValidation';

const validationMethods = {
  registration_number: (s?: string | null | undefined) =>
    fieldValidation.requiredRegNr(s, getMarket().marketCode),
  odometerReadingValue: fieldValidation.requiredNumber,
};

export default validationMethods;
